/**
 * @fileoverview Hook compartido para gestión de apertura y cierre de modales laterales (sidebar) en Inbox y otros módulos.
 * @module useSidebarModalMC
 * @category Hook - UI Layer
 * @since 1.0.0
 * @version 1.0.0
 */
import { useCallback, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SIDEBAR_ACTIONS } from '../../../../constants/actionsConstants';

/**
 * Hook UI Layer para gestión de apertura/cierre de modales laterales (sidebar) con referencias estables.
 *
 * Implementa el patrón de UI Layer, permitiendo reutilización y evitando re renders innecesarios mediante referencias.
 */
export function useSidebarModalMC({ refData }) {
  const dispatch = useDispatch();
  const refObj = useRef(refData);

  // Mantener referencia actualizada
  useEffect(() => {
    refObj.current = refData;
  }, [refData]);

  /**
   * Cierra el sidebar/modal lateral para la clave de componente dada.
   */
  const closeModal = useCallback((componentKey) => {
    dispatch({
      type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR,
      payload: componentKey ? { componentKey } : undefined
    });
  }, [dispatch]);

  /**
   * Abre el sidebar/modal lateral con props y payload personalizados.
   */
  const openModal = useCallback((props = {}, componentKey, payload = {}) => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey,
        props: {
          closeModal: () => closeModal(componentKey),
          ...refObj.current,
          ...props,
        },
        ...payload,
      }
    });
  }, [dispatch, closeModal]);

  return { openModal, closeModal };
}
